<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();
</script>

<div class="control-dialog-container">
  <div class="mobil-play-video-controls" on:click={() => dispatch('ok')}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      ><path fill="#100118" d="M8 4.5v15L19 12 8 4.5Z" /></svg
    >
  </div>
</div>

<style src="./playerControlDialog.scss"></style>
